import PageContainer from '@/components/page-container'
import { transformToUpdateUserDto } from '@/routes/admin/management/users/-components/user-dto'
import UserManagementForm from '@/routes/admin/management/users/-components/user-management-form'
import $api from '@/services/api'
import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'

export const Route = createFileRoute('/admin/management/users/$id')({
  component: UpdateUserManagement,
  staticData: {
    breadcrumb: 'Detail',
  },
  loader: async ({ params, context: { queryClient } }) => {
    await queryClient.ensureQueryData(
      $api.queryOptions('get', '/users/{id}', {
        params: {
          path: {
            id: params.id,
          },
        },
      }),
    )
  },
})

function UpdateUserManagement() {
  const { id } = Route.useParams()
  const { data, refetch } = $api.useSuspenseQuery('get', '/users/{id}', {
    params: {
      path: { id },
    },
  })

  const mutation = $api.useMutation('patch', '/users/{id}', {
    onSuccess: async () => {
      toast.success('User updated successfully')
      await refetch()
    },
    onError: (error) => {
      toast.error('Failed to update user', {
        description: (error as any)?.message || 'Something went wrong',
      })
    },
  })

  return (
    <PageContainer
      title="Update User Management"
      backUrl="/admin/management/users"
    >
      <UserManagementForm
        isEdit
        defaultValues={{
          name: data.data.name,
          email: data.data.email,
          phoneNumber: data.data.phoneNumber || '',
          address: data.data.address || '',
          roleId: data.data.roleId,
          status: data.data.status as 'Active' | 'Inactive',
          password: '',
          confirmPassword: '',
        }}
        onSubmit={async (formValues) => {
          await mutation.mutateAsync({
            body: transformToUpdateUserDto(formValues),
            params: {
              path: { id },
            },
          })
        }}
      />
    </PageContainer>
  )
}
